import store from '../store'
export function parse (key) {
  const keys = key.split('/')
  let result

  if (keys[0] === 'state') {
    result = store
    for (let i = 0; i < keys.length; i++) {
      result = result[keys[i]]
    }
  } else if (keys[0] === 'getters') {
    const [getter, ...info] = keys
    result = store[getter][info.join('/')]
  }

  return result
}

export function parseShow (key, trans) {
  let result = parse(key)
  if (trans !== '') {
    const transFunc = parse(trans)
    result = transFunc(result)
  }

  return result
}

export function parseList (key, rowId) {
  let result = parse(key)
  if (result instanceof Function) {
    result = result(rowId)
  }

  return result
}

export function parseColomnShow (row, prop, trans) {
  let result
  if (prop.indexOf('.') !== -1) {
    const props = prop.split('.')
    result = row
    props.forEach(p => {
      result = result[p]
    })
  } else {
    result = row[prop]
  }

  if (trans !== '') {
    const transFunc = parse(trans)
    result = transFunc(result)
  }

  return result
}

export function save (key, val, bus = null) {
  const keys = key.split('/')
  const [op, ...info] = keys
  if (op === 'commit') {
    store.commit(info.join('/'), val)
  } else {
    if (bus) {
      store.dispatch(info.join('/'), { data: val, bus: bus })
    } else {
      store.dispatch(info.join('/'), val)
    }
  }
}

export function exludeEmptyParams (params) {
  const out = {}
  for (let prop in params) {
    if (params[prop] === 9999 || params[prop] === 0 || params[prop] === '0' || params[prop] === '' || params[prop] === 'All') {
      continue
    }
    if (params[prop] === 'deliver preparing') {
      out[prop] = 0 // 暂时特殊处理一下
      continue
    }
    out[prop] = params[prop]
  }
  return out
}

export function parseCss (className, item) {
  if (className.indexOf('/') === -1) {
    return className
  } else {
    const css = parse(className)
    return css(item)
  }
}
